module.exports = __webpack_public_path__ + "img/base_hebergements_residence.f65f2f1e.svg";